import {ajax} from "src/commons/ajax";
import React, {useEffect, useState} from 'react';
import {createFromIconfontCN} from "@ant-design/icons";
import {Tag, Tooltip, Button, Badge} from "antd";


export const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_3023763_wiokl0zqhc.js',
});

///******Station**********////
export function getStationById(param) {
    return ajax.get('/api/station/getStationById', param).then(res => {
        return res.data;
    });
}

//********Factor ********//
export function getFactorById(param) {
    return ajax.get('/api/factor/getFactorById', param).then(res => {
        return res.data;
    });
}

export function getDevicesBySid(param) {
    return ajax.get('/api/factor/getFactorsBySid', param).then(res => {
        // console.log("res", res);
        return (res.rows || []).map(item => ({
            title: item.name + "[" + item.unit + "]",
            dataIndex: item.field,
            width: 100,
            align: 'center'
        }))
    });
}

export function getColumns(param) {
    return ajax.get('/api/factor/getShowFactors', param).then(res => {
        // console.log("res", res);
        return (res.rows || []).map(item => ({
            fid: item.fid,          // 因子id，供列筛选使用（antd 不会把它透传到 DOM）
            title: item.name + "(" + item.unit + ")",
            // dataIndex: item.field,
            // width: 100,
            align: 'center',
            children: [
                {
                    title: '[' + item.lower + '~' + item.limit + ']',
                    dataIndex: item.field,
                    align: 'center',
                    width: 120,
                    scopedSlots: {customRender: item.field + "v"},
                    render: (text, record, index, scoped) => {
                        return custColor(text, record, item, item.field + "v")
                    }
                }]
        }))
    });
}

export function gradeColor(text, record, index, scoped) {
    const c = record.range?.cvalue?.split(",");
    return text?<Tag color={convertToColor(c || ['255','140','35'])} title={"首要污染物:" + record?.rank?.mark || ""}>{text || "-"}</Tag>: ""
}

const convertToColor = ([r, g, b]) => {
    return `rgb(${r}, ${g}, ${b})`;
};

export function custColor(value, rocord, factor, flagField) {
    // console.log("rocord",rocord);

    const hour = new Date(rocord['datatime'] * 1000).getHours();

    if (factor.interval != 0 && (hour % (factor.interval / 60) != 0) && rocord['dtype'] == 2) {
        return <span title={"未授权"}>-</span>
    } else {
        if (value > factor.limit || value < factor.lower) {
            return <span style={{color: 'red'}} title={"上下限超标"}>{value}</span>;
        } else if (value == 0) {
            return <span style={{color: 'blue'}} title={"数据0值"}>{value}</span>;
        } else if (rocord[flagField] == 25 && factor.repeat == 0) {
            return <span style={{color: 'orange'}} title={"恒定值"}>{value}</span>;
        } else if (rocord[flagField] == 25 && factor.repeat == 1) {
            return <span style={{color: 'orange'}} title={"恒定值"}>-</span>;
        } else if (rocord[flagField] == -1) {
            return <span style={{color: 'yellow'}} title={"未上传"}>-</span>;
        } else if (rocord[flagField] == 30) {
            return <Badge status="success"><span title={"已审核"}>{value}</span></Badge>;
        } else {
            return <span>{value}</span>;
        }
    }
}

export function getTabTittle(ft) {
    let tittle = '实时数据';
    if (ft == 1) {
        tittle = '分钟数据';
    } else if (ft == 2) {
        tittle = '小时数据';
    } else if (ft == 3) {
        tittle = '日报表';
    } else if (ft == 4) {
        tittle = '月报表';
    } else if (ft == 5) {
        tittle = '年报表';
    } else if (ft == 6) {
        tittle = '统计分析';
    } else if (ft == 7) {
        tittle = '异常数据';
    } else if (ft == 8) {
        tittle = '质控核查';
    } else if (ft == 9) {
        tittle = '周报表';
    } else if (ft == -1) {
        tittle = '站点详情';
    } else if (ft == -2) {
        tittle = '控制记录';
    } else if (ft == -3) {
        tittle = '操作记录';
    } else if (ft == -4) {
        tittle = '报警消息';
    } else if (ft == -5) {
        tittle = '监控视频';
    } else if (ft == -6) {
        tittle = '流程日志';
    } else if (ft == -7) {
        tittle = '巡检记录';
    } else if (ft == -8) {
        tittle = '设备校准';
    } else if (ft == -9) {
        tittle = '耗材更换';
    } else if (ft == -10) {
        tittle = '废物处理';
    } else if (ft == -11) {
        tittle = '设备对比';
    } else if (ft == -12) {
        tittle = '报修记录';
    }
    return tittle;
}

export function getForward(ft) {
    let forward = '/realData';
    if (ft == 1) {
        forward = '/minData';
    } else if (ft == 2) {
        forward = '/hourData';
    } else if (ft == 3) {
        forward = '/reportDay';
    } else if (ft == 4) {
        forward = '/reportMonth';
    } else if (ft == 5) {
        forward = '/reportYear';
    } else if (ft == 6) {
        forward = '/census';
    } else if (ft == 7) {
        forward = '/realData';
    } else if (ft == 8) {
        forward = '/correct';
    } else if (ft == 9) {
        forward = '/reportWeek';
    } else if (ft == -1) {
        forward = '/station';
    } else if (ft == -2) {
        forward = '/control';
    } else if (ft == -3) {
        forward = '/operate';
    } else if (ft == -4) {
        forward = '/message';
    } else if (ft == -5) {
        forward = '/video';
    } else if (ft == -6) {
        forward = '/record';
    } else if (ft == -7) {
        forward = '/patrol';
    } else if (ft == -8) {
        forward = '/culture';
    } else if (ft == -9) {
        forward = '/material';
    } else if (ft == -10) {
        forward = '/waste';
    } else if (ft == -11) {
        forward = '/contrast';
    } else if (ft == -12) {
        forward = '/repair';
    }
    return forward;
}

export function renderPollute(val) {
    if (val === 1) {
        return <IconFont type="icon-feiqijiance"
                         style={{fontSize: '20px', color: '#08c'}} title={"废气监测"}/>;
    } else if (val === 2) {
        return <IconFont type="icon-feishui"
                         style={{fontSize: '20px', color: '#08c'}} title={"废水监测"}/>;
    } else if (val === 3) {
        return <IconFont type="icon-kongqizhiliang"
                         style={{fontSize: '20px', color: '#08c'}} title={"空气质量"}/>;
    } else if (val === 4) {
        return <IconFont type="icon-dibiaoshuishuiyuandi"
                         style={{fontSize: '20px', color: '#08c'}} title={"地表水监测"}/>;
    } else if (val === 5) {
        return <IconFont type="icon-zaosheng"
                         style={{fontSize: '20px', color: '#08c'}} title={"噪声监测"}/>;
    } else if (val === 6) {
        return <IconFont type="icon-turang"
                         style={{fontSize: '20px', color: '#08c'}} title={"土壤监测"}/>;
    } else {
        return <IconFont type="icon-uav"
                         style={{fontSize: '20px', color: '#08c'}} title={"移动监测"}/>;
    }
}

